const clearLocalStorageLogin = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('csrf_token');
  localStorage.removeItem('logout_token');
  localStorage.removeItem('user_data');
  localStorage.setItem('localstorage_login', 'false');
};

export default clearLocalStorageLogin;
